import styles from './style.module.scss';
import { Element } from 'react-scroll';
import { src } from '../../../utils/common';
import FadeIn from '../../commonComponents/fadeIn';
import { WebPNativeImage } from '../../WebPImage';
import { useState } from 'react';
import classnames from 'classnames';

const Advantage = ({ elementName, advantageData }) => {
  const [active, setActive] = useState(0);
  return (
    <Element name={elementName}>
      <FadeIn>
        <main className={styles['container']}>
          <div className={styles['title']}>{advantageData.title}</div>
          <section className={styles['cards']}>
            {advantageData.details.map((item, index) => (
              <div
                key={index}
                className={classnames({
                  [styles['card']]: true,
                  [styles['card-active']]: active === index,
                })}
                onMouseEnter={() => setActive(index)}
              >
                <div className={styles['card-title']}>{item.title}</div>
                <div className={styles['card-content']}>{item.content}</div>
                <WebPNativeImage
                  className={styles['reveal-img']}
                  src={src(item.iconUrl)}
                  alt=""
                />
              </div>
            ))}
          </section>
        </main>
      </FadeIn>
    </Element>
  );
};

export default Advantage;
